import React, { useContext } from 'react';
import { Amplify } from 'aws-amplify';
import config from '../../aws-exports';
import { cx } from '@emotion/css';
import * as styles from './welcome.style';
import isEmpty from 'lodash/isEmpty';

import welcomeHeroImg from '../../assets/professional_person.png';
import Features from './Features';
import { Link } from 'react-router-dom';
import { UserContext } from '../UserContext';

Amplify.configure(config);

function Welcome() {
  const { user } = useContext(UserContext);
  return (
    <div className={cx(styles.pageWrapper)}>
      <section className={cx(styles.heroContainer)}>
        <div className={cx(styles.heroLeft)}>
          <span className={cx(styles.welcomeText)}>Welcome to QuizWizard</span>
          <h1 className={cx(styles.headline)}>
            Make learning <span>awesome</span>
          </h1>
          <p className={cx(styles.line)}>
            QuizWizard delivers engaging learning to young minds. Spark your child’s curiosity for learning with our new playful app experience.
          </p>

          <div className="mt-4">
            {isEmpty(user) && (
              <Link to="/login" className={cx(styles.premiumButton)}>
                sign up for free
              </Link>
            )}
          </div>
        </div>

        <div className={cx(styles.heroRight)}>
          <div className={cx(styles.decorationCard1)}></div>
          <div className={cx(styles.decorationCard2)}></div>

          <div className={cx(styles.floatingShape, 'shape-plus')}>+</div>
          <div className={cx(styles.floatingShape, 'shape-triangle')}>▲</div>
          <div className={cx(styles.floatingShape, 'shape-circle')}>○</div>
          <div className={cx(styles.floatingShape, 'shape-zigzag')}>
            <svg viewBox="0 0 100 20" width="100" height="20">
              <path d="M0,10 L10,0 L20,10 L30,0 L40,10 L50,0 L60,10 L70,0 L80,10 L90,0 L100,10" fill="none" stroke="currentColor" strokeWidth="2" />
            </svg>
          </div>

          <img className={cx(styles.heroPersonImg)} src={welcomeHeroImg} alt="Welcome" />
        </div>
      </section>

      <Features />

      <section className="container text-center mt-5">
        {isEmpty(user) && (
          <Link to="/login" className={cx(styles.premiumButton)}>
            Get Started Now
          </Link>
        )}
      </section>
    </div>
  );
}

export default Welcome;
